
import { InjectionToken } from '@angular/core';

import { environment } from '../environments/environment';

export let APP_CONFIG = new InjectionToken('app.config');

export interface IAppConfig {
    HTML_ENDPOINT: string;
    API_ENDPOINT: string;
    S3_URL: string;
    IS_MAINTENANCE: boolean;
    VAULT_CLIENTID: string;
    PARTICA_ENDPOINT: string;
    PARTICA_PARTNERID: string;
    PARTICA_VIEWER_URL: string;
    VAULT_UK_CLIENTID: string;
    IS_UK: boolean;
}

export const AppConfig: IAppConfig = {
    HTML_ENDPOINT: environment.htmlEndpoint,
    API_ENDPOINT: environment.apiEndpoint,
    S3_URL: environment.s3BucketUrl,
    IS_MAINTENANCE: false,
    VAULT_CLIENTID: environment.vaultClientId,
    PARTICA_ENDPOINT: environment.particaEndpoint,
    PARTICA_PARTNERID: environment.particaPartnerId,
    PARTICA_VIEWER_URL: environment.particaViewerEndpoint,
    VAULT_UK_CLIENTID: environment.vaultUkClientId,
    IS_UK: environment.isUk
};



// WEBPACK FOOTER //
// ./src/app/app.config.ts